import React from 'react'
import './Registration.css'
import Layout from '../Layout'
import SignupFunction from '../../../utils/CommonFunctionality/SignupFunction'

const Registration = (props) => {
    return (
        <Layout>
            <div className="clearfix row regCnt">
                <div className="col-12">
                    <div className="loginFormBox">
                        <SignupFunction
                            // defaultCountryCode={38}
                            title="Signup"
                            subTitle="Create your free account today"
                            regpro={props}
                            // multipleUserRole={1}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Registration
